import React from 'react';
import Navbar from '../components/common/Navbar';
import Footer from '../components/common/Footer';
import './LegalPage.css';

const PrivacyPage = () => (
  <div className="legal-page">
    <Navbar />
    <main>
      <section className="legal-hero">
        <div className="legal-hero__inner">
          <p className="section-eyebrow">Legal</p>
          <h1 className="legal-hero__title">Privacy Policy</h1>
          <p className="legal-hero__date">Last updated: May 2026</p>
          <div className="gold-divider" style={{ maxWidth: 180, margin: '1.25rem auto 0' }} />
        </div>
      </section>

      <section className="legal-body">
        <div className="legal-body__inner">

          <LegalSection title="1. Who We Are">
            <p>VTD Astrology ("we", "us", "our") operates the website vtdastrology.com and the VTD Astrology mobile application. This privacy policy explains what personal data we collect, why we collect it, how we use and protect it, and the choices you have. By using our services you agree to the terms below.</p>
            <p>Operator contact: Tilak Datta Sharma, +91 93477 09596, tilakdatta1842003@gmail.com.</p>
          </LegalSection>

          <LegalSection title="2. Information We Collect">
            <p>We collect the following categories of information when you use our chat application, website, or contact us through messaging platforms:</p>
            <ul>
              <li><strong>Identity:</strong> Name, gender, date of birth, time of birth, place of birth — required to prepare your Vedic chart.</li>
              <li><strong>Contact:</strong> Phone number, email address, WhatsApp / Instagram / Telegram username when you initiate contact through those channels.</li>
              <li><strong>Conversation content:</strong> Text messages, voice messages and image uploads (e.g. palm photos, property photos, payment screenshots) that you send through the in-app chat. These are stored on our servers to deliver and review your consultation.</li>
              <li><strong>Service activity:</strong> Services you purchase, payment confirmations, consultation history, remedies recommended.</li>
              <li><strong>Device and session data:</strong> A locally-generated user ID stored in your device's local storage to associate your session with your chat history; basic device/browser information sent automatically by your browser; access logs (IP address, timestamps, pages visited) kept for security and abuse prevention.</li>
              <li><strong>Optional community posts:</strong> If you post in the community feed, the content of those posts and the time of posting.</li>
            </ul>
            <p>We do not collect financial card or bank account details — all payments are processed by external payment platforms (UPI apps, Razorpay) and we only see a payment screenshot or reference confirming completion.</p>
            <p>We do not use third-party advertising trackers, advertising IDs, Facebook Pixel, Google Analytics or similar profiling tools on the chat application.</p>
          </LegalSection>

          <LegalSection title="3. How We Use Your Information">
            <p>Your information is used to:</p>
            <ul>
              <li>Prepare your Vedic chart and deliver the consultation, course, or service you requested.</li>
              <li>Communicate with you about your consultation, remedies, follow-ups, and customer support.</li>
              <li>Verify payments and reconcile records.</li>
              <li>Improve service quality (reviewing past conversations to refine our reading methods and AI assistant).</li>
              <li>Detect and prevent abuse, fraud, and security incidents.</li>
              <li>Comply with legal obligations.</li>
            </ul>
            <p>We do not use your data for advertising and we do not sell, rent or share your data with third parties for their own marketing.</p>
          </LegalSection>

          <LegalSection title="4. Third-Party Service Providers">
            <p>To operate the service we share limited data with the following processors, each of whom is contractually bound to keep your information confidential and process it only on our behalf:</p>
            <ul>
              <li><strong>Google (Gemini API)</strong> and <strong>Anthropic (Claude API)</strong> — message content is sent to these AI services to power chat assistance, daily horoscope generation, and admin tools. These providers process the content transiently to generate a response and, per their terms, do not use API content to train their models.</li>
              <li><strong>Hosting provider</strong> — our VPS provider stores the application and database.</li>
              <li><strong>Astrology calculation API</strong> — used to compute planetary positions from your birth details.</li>
              <li><strong>Payment platforms</strong> — UPI apps and (where used) Razorpay handle the payment itself; we receive only the confirmation.</li>
              <li><strong>Email and messaging providers</strong> — WhatsApp, Instagram, Telegram when you contact us via those channels (their own privacy policies apply to those platforms).</li>
            </ul>
          </LegalSection>

          <LegalSection title="5. Data Retention">
            <p>We retain your chat history, voice notes, and uploaded images for up to <strong>24 months</strong> after your last interaction to enable follow-up consultations and service continuity. Aggregate, de-identified usage statistics may be retained longer. Access logs are retained for up to 90 days for security purposes.</p>
            <p>When you request deletion (see Section 7), we remove your personal data from our active systems within 30 days, except where retention is required by law (e.g., tax records).</p>
          </LegalSection>

          <LegalSection title="6. Security">
            <p>We protect your data using industry-standard measures: HTTPS encryption in transit, access controls limiting who on our team can view sessions, server-side authentication for administrative access, and regular review of stored data. No system is completely secure, however, and we cannot guarantee absolute security. If you believe your account has been compromised, contact us immediately.</p>
          </LegalSection>

          <LegalSection title="7. Your Rights and Account/Data Deletion">
            <p>You have the right to:</p>
            <ul>
              <li><strong>Access</strong> — request a copy of the personal data we hold about you.</li>
              <li><strong>Correct</strong> — ask us to fix inaccurate information.</li>
              <li><strong>Delete your account and data</strong> — remove your personal information from our systems.</li>
              <li><strong>Withdraw consent</strong> — stop further processing of your data going forward.</li>
              <li><strong>Object or complain</strong> — raise a privacy complaint with us or the relevant regulator.</li>
            </ul>
            <p><strong>To delete your account and data:</strong></p>
            <ul>
              <li><strong>In-app:</strong> Open the VTD Astrology app or vtdastrology.com/chat → Profile → "Delete my account". This permanently removes your chat history, uploaded images, voice notes, and session record.</li>
              <li><strong>Web form:</strong> Visit <a href="https://vtdastrology.com/delete-account">vtdastrology.com/delete-account</a>.</li>
              <li><strong>By message:</strong> WhatsApp +91 93477 09596 or email tilakdatta1842003@gmail.com with subject "Delete my data". Please include the phone number or email you used with us so we can locate your records.</li>
            </ul>
            <p>We process deletion requests within 30 days. Some information (basic transaction records required for tax law) may be retained in archived form for the period required by law, after which it is also deleted.</p>
          </LegalSection>

          <LegalSection title="8. Children's Privacy">
            <p>Our services are intended for individuals aged 18 and above. We do not knowingly collect data from anyone under 18. If we discover that we have collected data from a minor, we will delete it. If you believe a minor has used our service, please contact us immediately.</p>
          </LegalSection>

          <LegalSection title="9. Cookies and Local Storage">
            <p>Our website and chat application use browser local storage to keep you signed in and remember your session across visits. We do not use cross-site tracking cookies or third-party advertising cookies. You may clear local storage at any time through your browser settings; doing so will end your session.</p>
          </LegalSection>

          <LegalSection title="10. Changes to This Policy">
            <p>We may update this policy from time to time. The "Last updated" date at the top of this page reflects the most recent change. For material changes that affect how we use your data, we will notify you through the app or by message before the change takes effect.</p>
          </LegalSection>

          <LegalSection title="11. Disclaimer About Astrological Services">
            <p>Astrological readings, remedies, and guidance are offered for personal reflection and cultural / spiritual purposes only. They are not a substitute for professional medical, legal, financial, or psychological advice. Outcomes depend on many factors and cannot be guaranteed.</p>
          </LegalSection>

          <LegalSection title="12. Contact for Privacy Concerns">
            <p>For any privacy-related question, complaint, or data deletion request:</p>
            <ul>
              <li>Email: tilakdatta1842003@gmail.com</li>
              <li>WhatsApp: +91 93477 09596</li>
              <li>Postal: Tilak Datta Sharma, VTD Astrology, India</li>
            </ul>
            <p>We respond within 48 hours.</p>
          </LegalSection>

        </div>
      </section>
    </main>
    <Footer />
  </div>
);

const LegalSection = ({ title, children }) => (
  <div className="legal-section">
    <h2 className="legal-section__title">{title}</h2>
    <div className="legal-section__body">{children}</div>
  </div>
);

export default PrivacyPage;
